// extracted by mini-css-extract-plugin
export default {"svg":"ListIcon_svg__3U+Hu","active":"ListIcon_active__rmq8H"};